import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import {
  iOrganization,
  iOrganizationHelpDeskPipeline,
} from "@sdk/user-management/user-management.models";
import { UserTracker } from "user-tracker";

export class PipelineManagementServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.pipelines.config = config;
  }

  pipelines = Object.assign(
    { config: SDKConfig },
    {
      addPipeline: async (data: iOrganizationHelpDeskPipeline) => {
        UserTracker.track("PIPELINES - Create", {});
        const results: AxiosResponse<iOrganization> = await axios.post(
          this.config.basePath + `/organizations/pipelines`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      editPipeline: async (id: string, data: iOrganizationHelpDeskPipeline) => {
        UserTracker.track("PIPELINES - Edit", {});
        const results: AxiosResponse<iOrganization> = await axios.patch(
          this.config.basePath + `/organizations/pipelines/${id}`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      deletePipeline: async (id: string) => {
        UserTracker.track("PIPELINES - Delete", {});
        const results: AxiosResponse<iOrganization> = await axios.delete(
          this.config.basePath + `/organizations/pipelines/${id}`,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
    },
  );
}
